import { FC } from 'react';

import BoxInfoOffer from './BoxInfoOffer';
import dayjs from 'dayjs';

interface Props {
  insuranceCompany: string;
  insuranceLogo?: string;
  injuryNumber: string;
  injuryDate?: string;
  insuranceType: string;
  injuryType: string;
  valueOfInjury: number;
  tax: string;
}

const InjuryInfo: FC<Props> = ({
  insuranceCompany,
  // insuranceLogo,
  injuryNumber,
  injuryDate,
  insuranceType,
  injuryType,
  valueOfInjury,
  tax,
}) => {
  return (
    <div className="text-dark-gray-500 lg:max-w-[440px]">
      <h2 className="h4 mb-3 text-center">Dane Twojej szkody</h2>
      <div className="mb-[30px] hidden h-px w-full bg-dark-gray-100 lg:block" />
      <div className="grid grid-cols-2 gap-2 lg:gap-x-5 lg:gap-y-4">
        <div className="col-span-2 flex items-center justify-between rounded-md border border-dark-gray-100 p-3">
          <div>
            <p className="input-label-small font-medium text-dark-gray-300">
              Towarzystwo ubezpieczeniowe
            </p>
            <p className="body-small text-oxford-blue-500">
              {insuranceCompany}
            </p>
          </div>
          {/* hidden for now */}
          {/* <img
            src={insuranceLogo}
            alt={`${insuranceCompany}-logo`}
            className="aspect-square size-10 rounded-full"
          /> */}
        </div>
        <BoxInfoOffer label="Numer szkody" value={injuryNumber} />
        <BoxInfoOffer
          label="Data szkody"
          value={
            injuryDate ? `${dayjs(injuryDate).format('DD.MM.YYYY')} r.` : '-'
          }
        />
        <BoxInfoOffer label="Typ ubezpieczenia" value={insuranceType} />
        <BoxInfoOffer label="Rodzaj szkody" value={injuryType} />
        <BoxInfoOffer
          label="Wartość szkody według TU"
          value={valueOfInjury.toLocaleString('PL', {
            style: 'currency',
            currency: 'PLN',
            minimumFractionDigits: 0,
            maximumFractionDigits: 0,
          })}
        />
        <BoxInfoOffer label="Zaliczka na podatek" value={tax} />
      </div>
    </div>
  );
};

export default InjuryInfo;
